import React from "react";
import { createContext } from "react";
import { ProviderProps } from "./props";
import { isCloudSite } from "../electron-modules";
import mosaicLogo from "../viewer/textures/misc/mosaic-logo.png";
import { Theme } from "@mui/material";
import { createTheme } from "../theme";
import manifest from "../../package.json";

export type Brand = "solv3d" | "mosaic";

export const BrandingContext = createContext({
  companyName: null as string,
  appName: null as string,
  iconPath: null as string,
  theme: null as Theme
});

export const BrandingProvider = (props: ProviderProps) => {
  let brand: Brand = "solv3d";

  if (isCloudSite) {
    if (typeof window !== "undefined") {
      if (window.location.hostname === "mosaic.solv3d.com" || window.location.hostname === "engine.mosaic51.com") {
        brand = "mosaic";
      }
    }
  } else {
    if (manifest.brand) {
      brand = manifest.brand as Brand;
    }
  }

  const isMosaic = brand === "mosaic";

  const appName = isMosaic
    ? "Mosaic Engine"
    : "SOLV3D Engine";

  const companyName = isMosaic
    ? "Mosaic 51"
    : "Solv3D Inc.";

  const iconPath = isMosaic
    ? mosaicLogo
    : null;

  const theme = createTheme(brand);

  return (
    <BrandingContext.Provider value={{
      appName,
      companyName,
      iconPath,
      theme
    }}>
      {props.children}
    </BrandingContext.Provider>
  );
};